<section class="notif-panel" aria-labelledby="notif-panel-title">
  <!-- Header -->
  <header class="notif-header">
    <div class="notif-header-top">
      <h2 id="notif-panel-title">
        Notifications
      </h2>
      <div class="notif-header-actions">
        @if (!isLoading && unreadCount) {
        <button
          type="button"
          class="notif-link-btn"
          [disabled]="isMarkingAll"
          (click)="markAllAsRead()"
        >
          <mat-icon>done_all</mat-icon>
          Mark all as read
        </button>
        }
        <button
          type="button"
          class="notif-icon-btn"
          aria-label="Close notifications"
          (click)="close()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="notif-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="notif-tab"
        [class.active]="filter === 'all'"
        [attr.aria-selected]="filter === 'all'"
        (click)="setFilter('all')"
      >
        All
      </button>
      <button
        type="button"
        role="tab"
        class="notif-tab"
        [class.active]="filter === 'unread'"
        [attr.aria-selected]="filter === 'unread'"
        (click)="setFilter('unread')"
      >
        Unread
        @if (unreadCount) {
        <span class="notif-tab-badge">{{ unreadCount }}</span>
        }
      </button>
    </div>
  </header>

  <!-- Body -->
  <div class="notif-body" role="tabpanel">
    @if (isLoading) {
    @for (i of [1, 2, 3, 4, 5]; track i) {
    <div class="notif-skeleton">
      <ngx-skeleton-loader
        [theme]="{ width: '40px', height: '40px', 'border-radius': '50%', margin: 0, background: '#e9edff' }"
      />
      <div class="notif-skeleton-lines">
        <ngx-skeleton-loader
          [theme]="{ width: '70%', height: '12px', margin: '0 0 8px', background: '#e9edff' }"
        />
        <ngx-skeleton-loader
          [theme]="{ width: '45%', height: '10px', margin: 0, background: '#eef1ff' }"
        />
      </div>
    </div>
    }
    } @else if (hasError) {
    <div class="notif-state">
      <div class="notif-state-icon error"><mat-icon>cloud_off</mat-icon></div>
      <h3>Couldn't load notifications</h3>
      <p>Check your connection and try again.</p>
      <button type="button" class="notif-retry-btn" (click)="getNotifications()">
        Retry
      </button>
    </div>
    } @else {
    @for (group of groups; track group.label) {
    <div class="notif-group">
      <div class="notif-group-label">{{ group.label }}</div>
      <ul class="notif-list">
        @for (item of group.items; track trackById($index, item)) {
        <li>
          <div
            class="notif-item"
            role="button"
            tabindex="0"
            [class.unread]="!item.read"
            [class.clickable]="item.clickable || !item.read"
            (click)="open(item)"
            (keydown.enter)="open(item)"
            (keydown.space)="$event.preventDefault(); open(item)"
          >
            <div class="notif-avatar">
              @if (item.avatarUrl) {
              <img [src]="item.avatarUrl" [alt]="item.actorName" (error)="onAvatarError(item)" />
              } @else {
              <span class="notif-initials" [style.background]="item.avatarColor">{{
                item.initials
              }}</span>
              }
              <span class="notif-badge" [class]="'tone-' + item.tone">
                <mat-icon>{{ item.categoryIcon }}</mat-icon>
              </span>
            </div>

            <div class="notif-content">
              @if (item.structured) {
              <p class="notif-text">
                <span class="notif-actor">{{ item.actorName }}</span>
                {{ item.action }}
                @if (item.reference) {
                <span class="notif-ref">{{ item.reference }}</span>
                }
              </p>
              } @else {
              <p class="notif-text">{{ item.action }}</p>
              }
              <div class="notif-meta">
                <span>{{ item.structured ? item.categoryLabel : item.actorName }}</span>
                <span class="notif-meta-sep" aria-hidden="true"></span>
                <span
                  class="notif-time"
                  [matTooltip]="(item.date | date: 'medium') ?? ''"
                  matTooltipPosition="above"
                  >{{ item.relativeTime }}</span
                >
              </div>
            </div>

            @if (!item.read) {
            <button
              type="button"
              class="notif-mark-btn"
              matTooltip="Mark as read"
              matTooltipPosition="left"
              aria-label="Mark as read"
              (click)="markAsRead(item, $event)"
            >
              <span class="notif-dot"></span>
            </button>
            }
          </div>
        </li>
        }
      </ul>
    </div>
    } @empty {
    <div class="notif-state">
      <div class="notif-state-icon">
        <mat-icon>{{ filter === 'unread' ? 'mark_email_read' : 'notifications_none' }}</mat-icon>
      </div>
      @if (filter === 'unread') {
      <h3>You're all caught up</h3>
      <p>No unread notifications right now.</p>
      } @else {
      <h3>No notifications yet</h3>
      <p>Updates about your trips and expenses will appear here.</p>
      }
    </div>
    }
    }
  </div>
</section>
